import {makeGetHealthAvailableTimes} from 'main/factories/usecases';
import {makeGetHealthAvailableTimes as makeGetHealthAvailableTimesV1} from 'main/factories/usecases/private/booking-flow/remote-health-booking-v1';
import {sortAvailableTimes, sortByKey} from 'presentation/utils';

import {GetHealthAvailableTimesParams} from 'domain/usecases';
import {GetHealthAvailableTimesParams as GetHealthAvailableTimesParamsV1} from 'domain/usecases/private/booking-flow/health-V1';

async function getHealthAvailableTimes(params: GetHealthAvailableTimesParams) {
	const response = await makeGetHealthAvailableTimes().get(params);

	if (!response || !response.content) {
		return [];
	}

	const {content} = response;
	const parsedResponse = content.providers.map(item => {
		const listAvailableTimes = item.availableTimes;
		const isPreviousProvider = item.isPreviousProvider;
		return {
			professionalName: item.name,
			professionalCode: String(item.code),
			availableTimes: listAvailableTimes,
			recommendations: [],
			isFavorite: item.isFavorite,
			isPreviousProvider,
		};
	});

	return parsedResponse;
}

async function getHealthAvailableTimesV1(params: GetHealthAvailableTimesParamsV1) {
	const response = await makeGetHealthAvailableTimesV1().get(params);

	if (!response) return [];

	const {horariosPrestadores} = response;
	const parsedResponse = horariosPrestadores.map(item => {
		const listAvailableTimes = item.horariosDisponiveis;
		return {
			professionalName: item.nmPrestadorFisico,
			professionalCode: String(item.cdPrestadorFisico),
			availableTimes: sortAvailableTimes(listAvailableTimes),
			recommendations: item.dsRecomendacoes,
		};
	});
	const sortedAvailableTimesByProviderName = sortByKey(parsedResponse, 'professionalName');

	return sortedAvailableTimesByProviderName;
}

export {getHealthAvailableTimes, getHealthAvailableTimesV1};
